import { createRouter, createWebHistory } from 'vue-router'
import BasicRoutes from './BasicRoutes.js'

const router = createRouter({
  history: createWebHistory(''),
  routes: BasicRoutes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
  // scrollBehavior(to) {
  //   return to.hash ? { selector: to.hash, behavior: "smooth" } : { top: 0 };
  // },
})

const initialize = async (app) => {
  try {
    // 最后添加 404 路由，确保动态菜单路由已经先注册
    router.addRoute({
      path: '',
      name: 'NotFoundParent',
      component: () => import('@/layout/Layout.vue'),
      children: [
        {
          path: '/:pathMatch(.*)*',
          name: 'NotFound',
          component: () => import('@/views/error/NotFound.vue'),
          meta: {
            id: 'NotFound',
            componentName: 'NotFound',
            keepAlive: true,
            name: '页面未找到',
          },
        },
      ],
    })
  } catch (e) {
    console.error(e)
  }

  app.use(router)
}

export { initialize, router }
